<template lang="html">
  <div class="vip">
    <common-header></common-header>
    <div class="imgContainer">
    	<div><img src="../../../assets/img/aboutUsKv.png" /></div>
    </div>
    <div class="vipContainer">
    	<div class="usTab">入会方式
    		<img src="../../../assets/img/aboutUsTag.png" />
    	</div>
    	<div class="contentBox">
    		<div class="title">入会方式</div>
    		<div class="eng-title">administrative regulations</div>
    		<div class="abstract">
    			君弘财富俱乐部会员采取邀约制，资产达到一定级别的客户可成为对应级别的君弘财富俱乐部会员；您可通过君弘APP成为君弘财富会员。<br/>
				<!-- 国泰君安客户也可以通过君弘财富俱乐部官网、君弘APP主动成为君弘财富会员。<br/> -->
				<!-- 君弘财富会员的会员等级根据用户当前的总资产对应：<br/>
				[0，5)万元为普通会员；[5，50)万元为银卡会员；[50，500)万元为金卡会员；[500，1000)万元为钻石卡会员；[1000，+∞)万元为君享卡会员 -->
			</div>
    		<div class="tips">
    			<!-- 1、凡是资产达到一定级别的客户可成为对应级别的君弘财富俱乐部会员；<br/> -->
				君弘财富俱乐部会员权益会随时间推移不断升级和调整。最终解释权归国泰君安证券股份有限公司所有。
    		</div>
    	</div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
	import commonHeader from '../../../components/common/commonHeader'
	import commonFooter from '../../../components/common/commonFooter'
	import listKv from '../../../components/common/listKv'
	//接口
	import Server from '../../../server/server.js'
	export default {
	  	data(){
		  	return{
		  		items:[]
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		commonFooter,
	  		listKv,
	  	},
	  	created(){
	  		//
	  	},
	}
</script>

<style lang="less" scoped>
	.vip{
		.imgContainer{
			padding:0px 40px;
			width:100%;
			margin-top:150px;
			div{
				width:100%;
				border-radius:10px;
				overflow:hidden;
				img{
					width:100%;	
					height:340px;
				}
			}
		}
		.vipContainer{
			width:100%;
			margin-top:30px;
			padding:0 40px;
			.usTab{
				width:100%;
				height:80px;
				padding:0 30px;
				line-height:80px;
				background-image:linear-gradient(90deg, #f1e3bb 0%, #e0c385 100%);
				border-radius:10px;
				text-align:left;
				color:#ad8f5a;
				font-size:28px;
				img{
					width:32px;
					float:right;
					margin-top:24px;
				}
			}
			.contentBox{
				width:100%;
				margin-top:30px;
				text-align:left;
				.title{
					font-size:32px;
					color:#ad8f5a;
					letter-spacing:0;
					line-height:52px;
				}
				.eng-title{
					margin-top:10px;
					font-size:28px;
					color:#818181;
					letter-spacing:0;
					line-height:28px;
				}
				.abstract{
					margin-top:20px;
					font-size:28px;
					color:#000000;
					letter-spacing:0.07px;
					line-height:50px;
				}
				.tips{
					margin-top:40px;
					width:100%;
					font-size:24px;
					color:#000000;
					letter-spacing:0.07px;
					line-height:45px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/container/aboutUsPage/aboutUs/vipInfo.vue